import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { SxProps } from "@mui/material/styles";
import ToggleOnOutlinedIcon from "@mui/icons-material/ToggleOnOutlined";
import { InfoCard } from "src/design";
import { FeatureSwitch } from "src/business/configuration/featureSwitch";
import { colorTextMuted } from "src/design/tokens";
import { FeatureSwitchRow } from "./FeatureSwitchRow";

interface FeatureSwitchesTableProps {
  featureSwitches: FeatureSwitch[];
  /** Id of the switch whose toggle is currently in flight, if any. */
  pendingId: string | null;
  /** True when the empty list is the result of a search rather than an empty config. */
  filtered: boolean;
  onToggle: (featureSwitch: FeatureSwitch, active: boolean) => void;
  sx?: SxProps;
}

export const FeatureSwitchesTable = ({
  featureSwitches,
  pendingId,
  filtered,
  onToggle,
  sx,
}: FeatureSwitchesTableProps) => (
  <InfoCard
    title={`Feature Switches (${featureSwitches.length})`}
    icon={<ToggleOnOutlinedIcon fontSize="small" />}
    sx={sx}
  >
    {featureSwitches.length === 0 ? (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body2" sx={{ color: colorTextMuted }}>
          {filtered
            ? "No feature switches match your search."
            : "No feature switches yet."}
        </Typography>
      </Box>
    ) : (
      <Table size="small" sx={{ mt: -1 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600, pl: 0 }}>
              Name
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              ID
            </TableCell>
            <TableCell
              align="right"
              sx={{ color: colorTextMuted, fontWeight: 600, pr: 0 }}
            >
              State
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {featureSwitches.map((featureSwitch) => (
            <FeatureSwitchRow
              key={featureSwitch.id}
              featureSwitch={featureSwitch}
              pending={pendingId === featureSwitch.id}
              disabled={pendingId !== null}
              onToggle={onToggle}
            />
          ))}
        </TableBody>
      </Table>
    )}
  </InfoCard>
);
